export default function orderLimitsReducer(state = {
  orderLimits: [],
  orderLimit: {attributes:{}},
  editorInput: {},
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_ORDER_LIMIT_LIST_PENDING':
    case 'GET_ORDER_LIMIT_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_ORDER_LIMIT_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        orderLimits: action.payLoad.data,
      }
    }
    case 'GET_ORDER_LIMIT_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        orderLimit: action.payLoad.data,
      }
    }
    case 'GET_ORDER_LIMIT_LIST_REJECTED':
    case 'SAVE_ORDER_LIMIT_REJECTED':
    case 'GET_ORDER_LIMIT_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }
    case 'INITIALIZE_EDIT_ORDER_LIMIT_FULFILLED': {
      return {
        ...state,
        editorInput: {
          categories: action.payLoad.data,
          active: [{label: 'yes', value: 'true'}, {label: 'no', value: 'false'}]
        }
      }
    }
    case 'CLEAR_EDIT_ORDER_LIMIT': {
      return {
        ...state,
        order_limit: {attributes:{}}
      }
    }
  }
  return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/orderLimitsReducer.js